import GameTags, { peopleCount } from "../../../shared/components/other/GameTags/GameTags";
import { FormatDate } from "../../../shared/shared";
import Image from "../../../shared/components/other/Image/Image";
import { Link } from "react-router";

import ManageEventModal from "../../Organizer/modals/ManageEventModal/ManageEventModal";
import { useState } from "react";
import gameEditIcon from "../../Organizer/pics/edit.svg"
import GameCardSkeleton from "./GameCardSkeleton";

interface GameCardProps {
    openState: string;
    peopleCount: peopleCount;
    name: string;
    dateTime: string;
    address: string;
    imgSrc: any;
    tags?: Array<string>;
    slug?: "86916-straikbol-alushta-2004";
    canEdit?: boolean;
    isLoading?: boolean;
}

//дату передвавать в Iso бех хвостовой части 

//peopleCount ссделать самостоятельное округление
//Преобразование времени из ISO формате
//Поддержка any 
export default function GameCard(props: GameCardProps) {
    const { openState, peopleCount, name, dateTime, address, imgSrc, tags = [], slug, canEdit, isLoading } = props;

    const [isEditEventModalOpen, setIsEditEventModalOpen] = useState(false)

    if (isLoading) {
        return <GameCardSkeleton />;
    }

    const parsedTags = tags

    const date = FormatDate(dateTime);

    const no_photo = '../no_photo.svg'

    const editButton =
        <button
            className="gameCard-editButton"
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); setIsEditEventModalOpen(true) }}
        >
            <img src={gameEditIcon} alt="" />
        </button>

    let preview;

    if (!imgSrc) {
        preview = no_photo
    } else if (typeof (imgSrc) == typeof (""))
        preview = imgSrc;
    else {
        const imgObj = imgSrc.filter((obj: any) => { return obj.is_preview })[0]?.image_link || no_photo
        preview = imgObj
    }

    return (
        <>
            <Link className="gameCard" to={'/gameInfo/' + slug}>
                <div className="gameCard-container">
                    {canEdit && openState !== "completed" && openState !== "cancelled" && editButton}
                    <div className="gameCard-preview-container">
                        <Image resolution="slider" sizes='325px' src={preview} alt="" className="gameCard-preview" />
                    </div>
                    <GameTags openState={openState} peopleCount={peopleCount} additionalTags={parsedTags} tagClass='gameCard_tag'></GameTags>
                    <div className="gameCard-info">
                        <h3 className="gameCard-name">{name}</h3>
                        <div className="gameCard-textContainer">
                            <p className="gameCard-info-text gameCard-info-date">{date}</p>
                            <p className="gameCard-info-text gameCard-info-place">{address}</p>
                        </div>
                    </div>
                </div>
            </Link>
            {canEdit && isEditEventModalOpen && (
                <ManageEventModal
                    isOpen={isEditEventModalOpen}
                    setIsOpen={setIsEditEventModalOpen}
                    mode="edit"
                    eventSlug={slug}
                    eventName={name}
                />
            )}
        </>
    )
}